<template>
    <div class="basic_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{data.title}}</div>
        </div>
        <div class="item_img"><img :src="data.img"/></div>
        <div class="items_3">
            <div class="item">
                <div class="item_div1">
                    <p>
                        {{data.title}}
                    </p>
                    <p>{{$t('utils.stock')}}: {{ data.stock }}</p>
                </div>
                <div class="item_div2">
                    <div class="item_rate">
                        <p>{{data.rate}}</p>
                        <p>{{$t('utils.income')}}</p>
                    </div>
                    <div class="item_day">
                        <p>{{data.day}}{{$t('utils.day')}}</p>
                        <p>{{$t('Lease Term')}}</p>
                    </div>
                    <div class="item_min">
                        <p>{{$t('currency')}}{{data.min}}</p>
                        <p>{{$t('Rent Payable')}}</p>
                    </div>
                </div>
                <!--<div class="item_div3">
                            <span>{{$t('utils.scale')}}:{{$t('utils.moneyMark')}}{{data.total}}</span>
                            &lt;!&ndash; <span>   按日收益，到期还本</span> &ndash;&gt;
                        </div>-->
                <div class="item_div4">
                    <van-progress :percentage="data.percent"/>
                </div>
            </div>
            <div class="mt-10 mb-10 font-14 font-bold">{{$t('Device parameters')}}</div>
            <div class="item_content" v-html="data.content"></div>
            <div class="mt-10 mb-10 font-14 font-bold">{{$t('Contract Agreement')}}</div>
            <!-- 合同内容区域 -->
            <div id="contract-content" class="item_content" v-html="data.contract"></div>
            <div style="height: 90px;"></div>
            <div class="fixed-footer">
                <button v-if="data.percent < 100" type="button" @click="buy()">{{$t('Replace')}}</button>
                <button class="item_btn_over" v-if="data.percent>=100" type="button">{{$t('utils.investOver')}}</button>
            </div>
        </div>
        <van-dialog
                v-model="show_tz"
                show-cancel-button
                @confirm="confirm"
                :confirmButtonText="confirmBtn"
                :cancelButtonText="cancelBtn"
                :before-close="onBeforeClose"
        >
            <div style="text-align: center;padding: 20px 0" v-if="showCircle">
                <div style="padding: 10px 0">
                    Loading...
                </div>
                <van-circle
                        v-model="currentRate"
                        :rate="time"
                        :speed="100/(time/1000)"
                        :stroke-width="150"
                        :text="djs_text"
                />
            </div>
            <div class="items_3" v-else>
                <div class="item">
                    <div class="item_div1">
                        <p>{{data.title}}</p>
                    </div>
                    <div class="item_div2">
                        <div class="item_rate">
                            <p>{{data.rate}}</p>
                            <p>{{$t('utils.income')}}</p>
                        </div>
                        <div class="item_day">
                            <p>{{data.day}}{{$t('utils.day')}}</p>
                            <p>{{$t('Lease Term')}}</p>
                        </div>
                        <div class="item_min">
                            <p>{{$t('currency')}}{{data.min}}</p>
                            <p>{{$t('Rent Payable')}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <!--			<van-field v-model="number" type="number" :placeholder="$t('item.inputAmount')"/>-->
        </van-dialog>

        <!-- 优惠券列表 -->
        <van-popup
                v-model:show="showCoupon"
                round
                position="bottom"
                style="height: 90%; padding-top: 4px;"
        >
            <van-coupon-list
                    :enabled-title="$t('coupon.canUse')"
                    :disabled-title="$t('coupon.canNotUse')"
                    :close-button-text="$t('coupon.close')"
                    :show-exchange-bar="false"
                    :coupons="coupons"
                    :disabledCoupons="disabledCoupons"
                    :chosen-coupon="chosenCoupon"
                    @change="onChange"
                    @exchange="onExchange"
            />
        </van-popup>

        <!-- 签名 -->
        <van-action-sheet v-model="showSignaturePad" :title="$t('Sign the contract')">
            <div class="content">
                <canvas ref="canvas" height="100" style="border:1px solid #ccc;width: 100%;"
                        @touchstart.stop.prevent
                        @touchmove.stop.prevent
                        @touchend.stop.prevent>
                </canvas>
                <div class="btn-group">
                    <van-button color="#0b9444" plain @click="clear">{{$t('Clear')}}</van-button>
                    <van-button color="#0b9444" @click="save">{{$t('Confirm signature')}}</van-button>
                </div>
            </div>
        </van-action-sheet>

    </div>

</template>

<script>
    import SignaturePad from 'signature_pad';
    import jsPDF from 'jspdf';
    import html2canvas from 'html2canvas';
    import Fetch from "../../utils/fetch";
    import Vue from 'vue';
    import {Popup, CouponCell, CouponList, Progress, Dialog, Circle, Field} from 'vant';

    Vue.use(Popup).use(CouponCell).use(CouponList).use(Progress).use(Dialog).use(Circle).use(Field);
    export default {
        name: "itemDetail",
        data() {
            return {
                subCanBtn: false,
                data: {},
                show_tz: false,
                number: "-1",
                time: 0,
                upid: '',
                old_price: '',
                currentRate: 0,
                showCircle: false,
                confirmBtn: this.$t('utils.confirm'),
                cancelBtn: this.$t('utils.cancel'),
                chosenCoupon: -1,
                showCoupon: false,
                couponNums: 0,
                coupons: [],
                disabledCoupons: [],
                showSignaturePad: false,
                signaturePad: null,
                partyASign: require("@/assets/images/nvidia-sign.png"), // 甲方固定签名
            };
        },
        computed: {
            djs_text() {
                return this.currentRate.toFixed(0) + '%'
            }
        },
        created() {
            this.$parent.footer('item', false);
        },
        mounted() {
            localStorage.setItem('contract_image', '');
            this.upid = parseInt(this.$router.history.current.params.upid);
            this.start();
        },
        methods: {
            // 清除签名
            clear() {
                if (this.signaturePad) this.signaturePad.clear()
            },
            // 签名
            save() {
                if (this.signaturePad.isEmpty()) {
                    this.$toast(this.$t('Please sign first'));
                    return false;
                }
                // 插入甲方签名
                const a = document.getElementById("partyASign")
                const abottom = document.getElementById("partyASignBottom")
                if (a && !a.querySelector("img")) {
                    const img = document.createElement("img")
                    img.src = this.partyASign
                    img.className = "signature-img"
                    a.appendChild(img)
                }
                if (abottom && !abottom.querySelector("img")) {
                    const img = document.createElement("img")
                    img.src = this.partyASign
                    img.className = "signature-img"
                    abottom.appendChild(img)
                }

                // 插入乙方签名
                const b = document.getElementById("partyBSign")
                const bbottom = document.getElementById("partyBSignBottom")
                if (b) {
                    b.innerHTML = "" // 清空
                    const img = document.createElement("img")
                    img.src = this.signaturePad.toDataURL()
                    img.className = "signature-img"
                    b.appendChild(img)
                }
                if (bbottom) {
                    bbottom.innerHTML = "" // 清空
                    const img = document.createElement("img")
                    img.src = this.signaturePad.toDataURL()
                    img.className = "signature-img"
                    bbottom.appendChild(img)
                }

                // 插入签署日期
                const now = new Date()
                const month = String(now.getMonth() + 1).padStart(2, "0")
                const day = String(now.getDate()).padStart(2, "0")
                const year = now.getFullYear()
                const signDate = `${month}/${day}/${year}`
                const c = document.getElementById("partyASignData")
                const d = document.getElementById("partyBSignDate")
                if (c) {
                    c.innerText = signDate
                    d.innerText = signDate
                }

                // 插入合同开始日期
                const startMonth = document.getElementById("startMonth")
                const startDay = document.getElementById("startDay")
                const startYear = document.getElementById("startYear")
                startMonth.innerText = month
                startDay.innerText = day
                startYear.innerText = year

                // 插入合同结束日期
                now.setDate(now.getDate() + this.data.day)  // 当前日期 + 指定天数
                const end_month = String(now.getMonth() + 1).padStart(2, "0")
                const end_day = String(now.getDate()).padStart(2, "0")
                const end_year = now.getFullYear()
                const endMonth = document.getElementById("endMonth")
                const endDay = document.getElementById("endDay")
                const endYear = document.getElementById("endYear")
                endMonth.innerText = end_month
                endDay.innerText = end_day
                endYear.innerText = end_year

                this.showSignaturePad = false;
                this.show_tz = true;
            },
            // 导出pdf
            async exportPdf() {
                const element = document.getElementById("contract-content")

                // 1. 把 DOM 转换成 canvas
                const canvas = await html2canvas(element, {
                    scale: 2,   // 提高清晰度
                    useCORS: true
                })

                // 2. PDF 页面参数（A4 纸，单位 mm）
                const pdf = new jsPDF("p", "mm", "a4")
                const pageWidth = pdf.internal.pageSize.getWidth()
                const pageHeight = pdf.internal.pageSize.getHeight()

                // 3. 设置顶部和底部间距
                const marginTop = 10    // mm
                const marginBottom = 10 // mm
                const usablePageHeight = pageHeight - marginTop - marginBottom

                // 4. canvas 转换为图像数据
                const imgWidth = pageWidth
                const imgHeight = (canvas.height * imgWidth) / canvas.width

                // 5. 在大 canvas 上分割每一页
                let renderedHeight = 0
                while (renderedHeight < canvas.height) {
                    const pageCanvas = document.createElement("canvas")
                    pageCanvas.width = canvas.width
                    pageCanvas.height = (usablePageHeight * canvas.width) / pageWidth // 按比例换算像素高度

                    const pageCtx = pageCanvas.getContext("2d")

                    // 从大 canvas 截取对应部分画到小 canvas
                    pageCtx.drawImage(
                        canvas,
                        0, renderedHeight, canvas.width, pageCanvas.height, // 源区域
                        0, 0, canvas.width, pageCanvas.height              // 目标区域
                    )

                    const pageData = pageCanvas.toDataURL("image/png")
                    const pageImgHeight = (pageCanvas.height * imgWidth) / pageCanvas.width

                    if (renderedHeight === 0) {
                        pdf.addImage(pageData, "PNG", 0, marginTop, imgWidth, pageImgHeight)
                    } else {
                        pdf.addPage()
                        pdf.addImage(pageData, "PNG", 0, marginTop, imgWidth, pageImgHeight)
                    }

                    renderedHeight += pageCanvas.height
                }

                // 6. 下载
                pdf.save("contract.pdf")
            },
            onChange(index) {
                this.showCoupon = false;
                this.chosenCoupon = index;
                if (index == -1) {
                    this.data.min = this.old_price;
                } else {
                    this.data.min = this.data.min - this.coupons[index].valueDesc;
                }
            },
            onExchange() {
                return this.$toast(this.$t('coupon..couponCodeCantUse'));
            },
            async onBeforeClose(action, done) {
                if (action === "confirm") {
                    return done(false)
                } else {
                    done(true)
                }
            },
            start() {
                Fetch('/index/item_detail', {
                    id: this.$router.history.current.params.id,
                }).then(res => {
                    this.data = res.data;
                    this.old_price = this.data.min
                })
            },
            buy() {
                if(this.data.is_allow_stop) {
                    this.showSignaturePad = false;
                    this.show_tz = true;
                } else {
                    if (!this.signaturePad) {
                        this.showSignaturePad = true
                        this.$nextTick(() => {
                            if (!this.signaturePad) {
                                this.signaturePad = new SignaturePad(this.$refs.canvas)
                            }
                        })
                    } else {
                        this.showSignaturePad = false;
                        this.show_tz = true;
                    }
                }
            },
            async confirm() {
                if(!this.data.is_allow_stop) {
                    if (this.signaturePad.isEmpty()) {
                        this.$toast(this.$t('Please sign the contract first'));
                        this.showSignaturePad = true;
                        this.show_tz = false;
                        return false;
                    }
                }

                if (this.subCanBtn)
                    return false;
                let _this = this;
                if (!this.number) {
                    this.$toast(this.$t('item.inputAmount'));
                    return false;
                }
                let data = {
                    id: this.data.id,
                    upid: this.upid,
                    money: this.number
                };
                if (this.chosenCoupon != '-1') {
                    data['coupon'] = this.coupons[this.chosenCoupon].code;
                }
                this.subCanBtn = true;

                // 生成 FormData
                const formData = await this.generateContractFormData()

                if (this.data.min > 0) {
                    let that = this;
                    // 检测是否能升级
                    Fetch('/index/check_upgrade', formData).then(res => {
                        that.showCircle = true;
						localStorage.setItem('contract_image', res.data.contract_image);
                        that.$router.push('/invest/' + this.data.id + '/upid/' + this.upid);
                    }).catch(err => {
                        this.subCanBtn = false;
                        this.show_tz = false;
                    });
                } else {
                    Fetch("/index/item_upgrade", formData).then(r => {
                        _this.showCircle = true;
                        _this.time = 10000;
                        setTimeout(function () {
                            _this.$router.push("/task");
                        }, 10000)

                    }).catch(err => {
                        this.subCanBtn = false;
                        this.show_tz = false;
                    })
                }
            },
            // 封装请求参数生成 FormData
            generateContractFormData() {
                return new Promise(async (resolve, reject) => {
                    try {
                        const element = document.getElementById("contract-content")
                        const canvas = await html2canvas(element, {scale: 2, useCORS: true})

                        canvas.toBlob(blob => {
                            if (!blob) {
                                reject(new Error("生成合同图片失败"))
                                return
                            }

                            const formData = new FormData()
                            formData.append("id", this.data.id)
                            formData.append("upid", this.upid)
                            formData.append("money", this.number)
                            formData.append("contractImage", blob, "contract.png")

                            if (this.chosenCoupon != "-1") {
                                formData.append("coupon", this.coupons[this.chosenCoupon].value)
                            }

                            resolve(formData)
                        }, "image/png")
                    } catch (err) {
                        reject(err)
                    }
                })
            },
        }
    };
</script>

<style lang="less" scoped>
    .basic_wrap {
        overscroll-behavior-x: none;
        touch-action: pan-y;
    }
    /deep/ .van-cell {
        padding: 2px 20px;
    }

    /deep/ .van-cell__left-icon, .van-cell__right-icon {
        line-height: 32px;
    }

    .red_top_bg {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;
    }

    .back_left {
        background: url(../../views/images/item/back_b.png) no-repeat center center;
    }

    .big_tit {
        left: 40px;
        width: 90%;
        color: #000000;
        transform: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
    }

    .item_img {
        margin: 45px 2% 0 2%;
        width: 96%;

        img {
            width: 100%;
        }
    }

    .items_3 {
        margin: 5px 2% 0 2%;
        width: 96%;

        .item {
            background: #FFFFFF;
            margin-bottom: 10px;

            div {
                margin: 5px 0;
            }

            .item_div1 {
                display: flex;
                justify-content: space-between;
                border-bottom: 1px solid #ECECEC;
                padding: 15px 10px;

                p:nth-child(1) {
                    // width: 90%;
                    font-weight: bold;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;

                }

                p:nth-child(2) {
                    color: #999;
                }
            }

            .item_div2 {
                display: flex;
                justify-content: space-between;
                text-align: center;
                font-size: 14px;

                div {
                    width: 33.33%;

                    p {
                        padding: 5px 0;
                    }
                }

                .item_rate {
                    p:nth-child(1) {
                        font-weight: bold;
                        color: #FF0000;

                    }

                    p:nth-child(2) {
                        color: #999;
                    }
                }

                .item_day {
                    p:nth-child(1) {
                        font-weight: bold;
                    }

                    p:nth-child(2) {
                        color: #999;
                    }
                }

                .item_min {
                    p:nth-child(1) {
                        font-weight: bold;

                    }

                    p:nth-child(2) {
                        color: #999;
                    }
                }
            }

            .item_div3 {
                color: #999;
                padding: 5px 10px;
            }

            .item_div4 {
                padding: 5px 10px;

                div:nth-child(1) {
                    width: 100%;
                    margin-top: 16px;
                    margin-bottom: 10px;
                }
            }

            .item_btn {
                width: 70%;
                position: absolute;
                bottom: 20px;
                margin-left: 13%;

                button {
                    width: 100%;
                    color: #fff;
                    padding: 10px 5px;
                    border-radius: 5px;
                    border: 1px solid #e9c78c;
                    background: #e9c78c;
                }

                .item_btn_over {
                    color: #999;
                    border: 1px solid #999;
                }
            }
        }

        .item_content {
            background: #FFFFFF;
            padding: 10px;
            line-height: 20px;
        }
    }

    .content {
        padding: 16px 16px 60px;
        overscroll-behavior: contain;
        touch-action: none;
    }

    .btn-group {
        margin-top: 10px;
        margin-bottom: 10px;
        display: flex;
        gap: 10px; /* 按钮之间的间距 */
    }

    .btn-group .van-button {
        flex: 1; /* 平分宽度 */
    }
</style>
